import React from 'react'
const ModalContext = React.createContext('modal')
export default ModalContext
